/*global VeloxGridAndFormController, VeloxFormController*/


/**
 * This is a basic MVC grid/form controller
 * 
 * It creates 2 routes : #category/list and #category/form
 */
var categoryController = new VeloxGridAndFormController("category", {
    grid : {
        directory: "views/category",
        name: "categoryGrid",
    },
    form : {
        directory: "views/category",
        name: "categoryForm",
    }
});



categoryController.formController.getRecordsToSave = function(viewData, dataBeforeModif, callback){
    if(dataBeforeModif && viewData.c_code !== dataBeforeModif.c_code){
        //the code (primary key) has been changed, must use a updateWhere 
        //(cascade on foreign key will update other tables)

        var records = [] ;
        records.push({
            table: "category",
            action: "updateWhere",
            record: {
                values: viewData,
                conditions: {c_code: dataBeforeModif.c_code},
            }
        }) ;
        callback(null, records) ;
    }else{
        //the code has not been changed, use normal method
        VeloxFormController.prototype.getRecordsToSave.call(this,viewData, dataBeforeModif, callback) ;
    }
};

module.exports = categoryController ;